import { render, staticRenderFns } from "./details_application.vue?vue&type=template&id=61b7fe54&"
import script from "./details_application.vue?vue&type=script&lang=js&"
export * from "./details_application.vue?vue&type=script&lang=js&"
import style0 from "./details_application.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports